import styled from 'styled-components'
import { Mode } from '@ocean/types/dist/appearance'
import { ActivityLabelProps } from './ActivityLabel'

type TextProps = {
  mode: ActivityLabelProps['mode']
}

export const Root = styled.div`
  display: flex;
`

export const Content = styled.div`
  flex: 1 0;

  ${({ theme }) => `
    color: ${theme.color.grey};
  `}
`

export const Title = styled.div<TextProps>`
  ${({ mode, theme }) =>
    mode === Mode.Dark &&
    `
    color: ${theme.color.white};
  `}
`

export const Info = styled.div<TextProps>`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.bold};
  `}

  ${({ mode, theme }) =>
    mode === Mode.Dark &&
    `
    color: ${theme.color.white};
  `}
`
